// extracted by mini-css-extract-plugin
export var backButton = "NavigationFooter_backButton__Wqw6I";
export var md = "768px";
export var navigationFooterContainer = "NavigationFooter_navigationFooterContainer__lQ4mi";
export var nextButton = "NavigationFooter_nextButton__5maJ8";
export var shared = "'../../shared.module.css'";